// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epw-coverage-page {
  --epw-red: var(--primary);
  --epw-red-dark: var(--primary-hover);
  --epw-ink: var(--text-primary);
  --epw-muted: var(--text-secondary);
  --epw-line: var(--border);
  --epw-soft: var(--hover);
  --epw-white: var(--card-bg);
  --epw-max-width: 1120px;
  --epw-radius: 18px;
  --epw-band-bg: var(--surface-dark);
  --epw-shadow: 0 10px 30px var(--shadow);
}

    .epw-coverage-page, .epw-coverage-page * { box-sizing: border-box; }

    .epw-coverage-page {
      font-family:
        Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
        "Segoe UI", sans-serif;
      color: var(--epw-ink);
      background: var(--epw-white);
      line-height: 1.6;
    }

    .epw-coverage-page {
      width: 100%;
    }

    .epw-wrap {
      width: min(100%, var(--epw-max-width));
      margin: 0 auto;
    }

    .epw-coverage-hero {
      padding: 78px 24px 72px;
      background:
        radial-gradient(circle at 80% 20%, rgba(200, 16, 46, 0.12), transparent 30%),
        linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
      border-bottom: 1px solid var(--epw-line);
    }

    .epw-hero-grid {
      display: grid;
      grid-template-columns: 1.05fr 0.95fr;
      gap: 50px;
      align-items: center;
    }

    .epw-eyebrow {
      margin: 0 0 12px;
      color: var(--epw-red);
      font-size: 0.8rem;
      font-weight: 800;
      letter-spacing: 0.12em;
      text-transform: uppercase;
    }

    .epw-coverage-hero h1 {
      margin: 0;
      max-width: 760px;
      font-size: clamp(2.4rem, 5vw, 4.5rem);
      line-height: 1.05;
      letter-spacing: -0.04em;
    }

    .epw-coverage-hero p {
      max-width: 760px;
      margin: 22px 0 0;
      color: var(--epw-muted);
      font-size: clamp(1.05rem, 2vw, 1.22rem);
    }

    .epw-globe-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .epw-globe {
      position: relative;
      width: min(100%, 390px);
      aspect-ratio: 1;
      border: 2px solid #d8dde6;
      border-radius: 50%;
      background:
        linear-gradient(90deg, transparent 49.5%, #e4e7ec 50%, transparent 50.5%),
        linear-gradient(0deg, transparent 49.5%, #e4e7ec 50%, transparent 50.5%),
        radial-gradient(circle at 50% 50%, #ffffff 0%, #f7f8fa 70%, #eef1f5 100%);
      box-shadow: var(--epw-shadow);
      overflow: hidden;
    }

    .epw-globe::before,
    .epw-globe::after {
      content: "";
      position: absolute;
      inset: 9% 28%;
      border: 1px solid #e4e7ec;
      border-radius: 50%;
    }

    .epw-globe::after {
      inset: 28% 9%;
    }

    .epw-region-dot {
      position: absolute;
      width: 16px;
      height: 16px;
      background: var(--epw-red);
      border-radius: 50%;
      box-shadow: 0 0 0 8px rgba(200, 16, 46, 0.12);
    }

    .epw-region-dot span {
      position: absolute;
      top: 24px;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      font-size: 0.74rem;
      font-weight: 800;
      /* Fixed (not themed) — the globe illustration stays pale in both
         light and dark mode, so its labels need to stay dark-on-light
         to match, regardless of --epw-ink. */
      color: #172033;
      background: rgba(255,255,255,.92);
      padding: 3px 7px;
      border-radius: 8px;
      border: 1px solid var(--epw-line);
    }

    .epw-dot-asia { top: 39%; left: 69%; }
    .epw-dot-mena { top: 43%; left: 52%; }
    .epw-dot-africa { top: 61%; left: 51%; }

    .epw-main {
      padding: 64px 24px 78px;
    }

    .epw-section-head {
      max-width: 780px;
      margin-bottom: 28px;
    }

    .epw-section-head h2 {
      margin: 0;
      font-size: clamp(1.9rem, 3vw, 2.7rem);
      line-height: 1.15;
      letter-spacing: -0.03em;
    }

    .epw-section-head p {
      margin: 13px 0 0;
      color: var(--epw-muted);
      font-size: 1.02rem;
    }

    .epw-region-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0,1fr));
      gap: 18px;
    }

    .epw-region-card {
      min-height: 275px;
      border: 1px solid var(--epw-line);
      border-radius: var(--epw-radius);
      padding: 24px;
      background: var(--epw-white);
      box-shadow: var(--epw-shadow);
      display: flex;
      flex-direction: column;
    }

    .epw-region-tag {
      display: inline-flex;
      align-self: flex-start;
      margin-bottom: 18px;
      padding: 6px 10px;
      border-radius: 999px;
      background: rgba(200, 16, 46, 0.08);
      color: var(--epw-red);
      font-size: 0.78rem;
      font-weight: 800;
      letter-spacing: 0.04em;
      text-transform: uppercase;
    }

    .epw-region-card h3 {
      margin: 0 0 10px;
      font-size: 1.35rem;
    }

    .epw-region-card p {
      margin: 0;
      color: var(--epw-muted);
    }

    .epw-region-card ul {
      margin: 18px 0 0;
      padding-left: 18px;
      color: var(--epw-muted);
      font-size: 0.94rem;
    }

    .epw-region-card li + li {
      margin-top: 6px;
    }

    .epw-global-band {
      margin-top: 56px;
      padding: 34px;
      border-radius: 20px;
      background: var(--epw-band-bg);
      color: #ffffff;
      display: grid;
      grid-template-columns: 0.8fr 1.2fr;
      gap: 34px;
      align-items: start;
    }

    .epw-global-band h2 {
      margin: 0;
      font-size: clamp(1.7rem, 3vw, 2.45rem);
      line-height: 1.15;
      letter-spacing: -0.03em;
    }

    .epw-global-band p {
      margin: 0;
      color: #d7dce5;
      font-size: 1rem;
    }

    .epw-expansion {
      margin-top: 58px;
    }

    .epw-expansion-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0,1fr));
      gap: 18px;
      margin-top: 24px;
    }

    .epw-future-card {
      border: 1px dashed #cfd5dd;
      border-radius: var(--epw-radius);
      padding: 24px;
      background: var(--epw-soft);
    }

    .epw-future-label {
      display: inline-block;
      margin-bottom: 12px;
      color: var(--epw-red);
      font-size: 0.76rem;
      font-weight: 800;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }

    .epw-future-card h3 {
      margin: 0 0 8px;
      font-size: 1.3rem;
    }

    .epw-future-card p {
      margin: 0;
      color: var(--epw-muted);
    }

    .epw-closing {
      margin-top: 54px;
      padding: 30px;
      border: 1px solid var(--epw-line);
      border-radius: 18px;
      text-align: center;
    }

    .epw-closing strong {
      display: block;
      font-size: clamp(1.35rem, 2.5vw, 1.9rem);
      margin-bottom: 8px;
    }

    .epw-closing p {
      margin: 0 auto;
      max-width: 760px;
      color: var(--epw-muted);
    }

    @media (max-width: 900px) {
      .epw-hero-grid,
      .epw-global-band {
        grid-template-columns: 1fr;
      }

      .epw-region-grid {
        grid-template-columns: 1fr;
      }

      .epw-globe {
        width: min(100%, 330px);
      }
    }

    @media (max-width: 700px) {
      .epw-expansion-grid {
        grid-template-columns: 1fr;
      }
    }

    @media (max-width: 620px) {
      .epw-coverage-hero {
        padding: 54px 20px 50px;
      }

      .epw-main {
        padding: 44px 18px 60px;
      }

      .epw-global-band,
      .epw-closing,
      .epw-region-card,
      .epw-future-card {
        padding: 22px;
      }
    }
  `, "",{"version":3,"sources":["webpack://./src/pages/CoveragePage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;AACzC;;IAEI,2CAA2C,sBAAsB,EAAE;;IAEnE;MACE;;8BAEwB;MACxB,qBAAqB;MACrB,4BAA4B;MAC5B,gBAAgB;IAClB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,sCAAsC;MACtC,cAAc;IAChB;;IAEA;MACE,uBAAuB;MACvB;;yDAEmD;MACnD,wCAAwC;IAC1C;;IAEA;MACE,aAAa;MACb,oCAAoC;MACpC,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,qBAAqB;MACrB,iBAAiB;MACjB,gBAAgB;MAChB,sBAAsB;MACtB,yBAAyB;IAC3B;;IAEA;MACE,SAAS;MACT,gBAAgB;MAChB,qCAAqC;MACrC,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,uBAAuB;MACvB,uCAAuC;IACzC;;IAEA;MACE,aAAa;MACb,uBAAuB;MACvB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,uBAAuB;MACvB,eAAe;MACf,yBAAyB;MACzB,kBAAkB;MAClB;;;iFAG2E;MAC3E,6BAA6B;MAC7B,gBAAgB;IAClB;;IAEA;;MAEE,WAAW;MACX,kBAAkB;MAClB,aAAa;MACb,yBAAyB;MACzB,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,0BAA0B;MAC1B,kBAAkB;MAClB,6CAA6C;IAC/C;;IAEA;MACE,kBAAkB;MAClB,SAAS;MACT,SAAS;MACT,2BAA2B;MAC3B,mBAAmB;MACnB,kBAAkB;MAClB,gBAAgB;MAChB;;6CAEuC;MACvC,cAAc;MACd,iCAAiC;MACjC,gBAAgB;MAChB,kBAAkB;MAClB,iCAAiC;IACnC;;IAEA,gBAAgB,QAAQ,EAAE,SAAS,EAAE;IACrC,gBAAgB,QAAQ,EAAE,SAAS,EAAE;IACrC,kBAAkB,QAAQ,EAAE,SAAS,EAAE;;IAEvC;MACE,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,SAAS;MACT,qCAAqC;MACrC,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,+CAA+C;MAC/C,SAAS;IACX;;IAEA;MACE,iBAAiB;MACjB,iCAAiC;MACjC,gCAAgC;MAChC,aAAa;MACb,4BAA4B;MAC5B,6BAA6B;MAC7B,aAAa;MACb,sBAAsB;IACxB;;IAEA;MACE,oBAAoB;MACpB,sBAAsB;MACtB,mBAAmB;MACnB,iBAAiB;MACjB,oBAAoB;MACpB,mCAAmC;MACnC,qBAAqB;MACrB,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB;MACtB,yBAAyB;IAC3B;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,cAAc;MACd,aAAa;MACb,kCAAkC;MAClC,SAAS;MACT,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,sCAAsC;MACtC,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,SAAS;MACT,cAAc;MACd,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,+CAA+C;MAC/C,SAAS;MACT,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;MAC1B,gCAAgC;MAChC,aAAa;MACb,2BAA2B;IAC7B;;IAEA;MACE,qBAAqB;MACrB,mBAAmB;MACnB,qBAAqB;MACrB,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB;MACtB,yBAAyB;IAC3B;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,SAAS;MACT,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,aAAa;MACb,iCAAiC;MACjC,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,wCAAwC;MACxC,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE;;QAEE,0BAA0B;MAC5B;;MAEA;QACE,0BAA0B;MAC5B;;MAEA;QACE,uBAAuB;MACzB;IACF;;IAEA;MACE;QACE,0BAA0B;MAC5B;IACF;;IAEA;MACE;QACE,uBAAuB;MACzB;;MAEA;QACE,uBAAuB;MACzB;;MAEA;;;;QAIE,aAAa;MACf;IACF","sourcesContent":[".epw-coverage-page {\n  --epw-red: var(--primary);\n  --epw-red-dark: var(--primary-hover);\n  --epw-ink: var(--text-primary);\n  --epw-muted: var(--text-secondary);\n  --epw-line: var(--border);\n  --epw-soft: var(--hover);\n  --epw-white: var(--card-bg);\n  --epw-max-width: 1120px;\n  --epw-radius: 18px;\n  --epw-band-bg: var(--surface-dark);\n  --epw-shadow: 0 10px 30px var(--shadow);\n}\n\n    .epw-coverage-page, .epw-coverage-page * { box-sizing: border-box; }\n\n    .epw-coverage-page {\n      font-family:\n        Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,\n        \"Segoe UI\", sans-serif;\n      color: var(--epw-ink);\n      background: var(--epw-white);\n      line-height: 1.6;\n    }\n\n    .epw-coverage-page {\n      width: 100%;\n    }\n\n    .epw-wrap {\n      width: min(100%, var(--epw-max-width));\n      margin: 0 auto;\n    }\n\n    .epw-coverage-hero {\n      padding: 78px 24px 72px;\n      background:\n        radial-gradient(circle at 80% 20%, rgba(200, 16, 46, 0.12), transparent 30%),\n        linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);\n      border-bottom: 1px solid var(--epw-line);\n    }\n\n    .epw-hero-grid {\n      display: grid;\n      grid-template-columns: 1.05fr 0.95fr;\n      gap: 50px;\n      align-items: center;\n    }\n\n    .epw-eyebrow {\n      margin: 0 0 12px;\n      color: var(--epw-red);\n      font-size: 0.8rem;\n      font-weight: 800;\n      letter-spacing: 0.12em;\n      text-transform: uppercase;\n    }\n\n    .epw-coverage-hero h1 {\n      margin: 0;\n      max-width: 760px;\n      font-size: clamp(2.4rem, 5vw, 4.5rem);\n      line-height: 1.05;\n      letter-spacing: -0.04em;\n    }\n\n    .epw-coverage-hero p {\n      max-width: 760px;\n      margin: 22px 0 0;\n      color: var(--epw-muted);\n      font-size: clamp(1.05rem, 2vw, 1.22rem);\n    }\n\n    .epw-globe-wrap {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .epw-globe {\n      position: relative;\n      width: min(100%, 390px);\n      aspect-ratio: 1;\n      border: 2px solid #d8dde6;\n      border-radius: 50%;\n      background:\n        linear-gradient(90deg, transparent 49.5%, #e4e7ec 50%, transparent 50.5%),\n        linear-gradient(0deg, transparent 49.5%, #e4e7ec 50%, transparent 50.5%),\n        radial-gradient(circle at 50% 50%, #ffffff 0%, #f7f8fa 70%, #eef1f5 100%);\n      box-shadow: var(--epw-shadow);\n      overflow: hidden;\n    }\n\n    .epw-globe::before,\n    .epw-globe::after {\n      content: \"\";\n      position: absolute;\n      inset: 9% 28%;\n      border: 1px solid #e4e7ec;\n      border-radius: 50%;\n    }\n\n    .epw-globe::after {\n      inset: 28% 9%;\n    }\n\n    .epw-region-dot {\n      position: absolute;\n      width: 16px;\n      height: 16px;\n      background: var(--epw-red);\n      border-radius: 50%;\n      box-shadow: 0 0 0 8px rgba(200, 16, 46, 0.12);\n    }\n\n    .epw-region-dot span {\n      position: absolute;\n      top: 24px;\n      left: 50%;\n      transform: translateX(-50%);\n      white-space: nowrap;\n      font-size: 0.74rem;\n      font-weight: 800;\n      /* Fixed (not themed) — the globe illustration stays pale in both\n         light and dark mode, so its labels need to stay dark-on-light\n         to match, regardless of --epw-ink. */\n      color: #172033;\n      background: rgba(255,255,255,.92);\n      padding: 3px 7px;\n      border-radius: 8px;\n      border: 1px solid var(--epw-line);\n    }\n\n    .epw-dot-asia { top: 39%; left: 69%; }\n    .epw-dot-mena { top: 43%; left: 52%; }\n    .epw-dot-africa { top: 61%; left: 51%; }\n\n    .epw-main {\n      padding: 64px 24px 78px;\n    }\n\n    .epw-section-head {\n      max-width: 780px;\n      margin-bottom: 28px;\n    }\n\n    .epw-section-head h2 {\n      margin: 0;\n      font-size: clamp(1.9rem, 3vw, 2.7rem);\n      line-height: 1.15;\n      letter-spacing: -0.03em;\n    }\n\n    .epw-section-head p {\n      margin: 13px 0 0;\n      color: var(--epw-muted);\n      font-size: 1.02rem;\n    }\n\n    .epw-region-grid {\n      display: grid;\n      grid-template-columns: repeat(3, minmax(0,1fr));\n      gap: 18px;\n    }\n\n    .epw-region-card {\n      min-height: 275px;\n      border: 1px solid var(--epw-line);\n      border-radius: var(--epw-radius);\n      padding: 24px;\n      background: var(--epw-white);\n      box-shadow: var(--epw-shadow);\n      display: flex;\n      flex-direction: column;\n    }\n\n    .epw-region-tag {\n      display: inline-flex;\n      align-self: flex-start;\n      margin-bottom: 18px;\n      padding: 6px 10px;\n      border-radius: 999px;\n      background: rgba(200, 16, 46, 0.08);\n      color: var(--epw-red);\n      font-size: 0.78rem;\n      font-weight: 800;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n    }\n\n    .epw-region-card h3 {\n      margin: 0 0 10px;\n      font-size: 1.35rem;\n    }\n\n    .epw-region-card p {\n      margin: 0;\n      color: var(--epw-muted);\n    }\n\n    .epw-region-card ul {\n      margin: 18px 0 0;\n      padding-left: 18px;\n      color: var(--epw-muted);\n      font-size: 0.94rem;\n    }\n\n    .epw-region-card li + li {\n      margin-top: 6px;\n    }\n\n    .epw-global-band {\n      margin-top: 56px;\n      padding: 34px;\n      border-radius: 20px;\n      background: var(--epw-band-bg);\n      color: #ffffff;\n      display: grid;\n      grid-template-columns: 0.8fr 1.2fr;\n      gap: 34px;\n      align-items: start;\n    }\n\n    .epw-global-band h2 {\n      margin: 0;\n      font-size: clamp(1.7rem, 3vw, 2.45rem);\n      line-height: 1.15;\n      letter-spacing: -0.03em;\n    }\n\n    .epw-global-band p {\n      margin: 0;\n      color: #d7dce5;\n      font-size: 1rem;\n    }\n\n    .epw-expansion {\n      margin-top: 58px;\n    }\n\n    .epw-expansion-grid {\n      display: grid;\n      grid-template-columns: repeat(2, minmax(0,1fr));\n      gap: 18px;\n      margin-top: 24px;\n    }\n\n    .epw-future-card {\n      border: 1px dashed #cfd5dd;\n      border-radius: var(--epw-radius);\n      padding: 24px;\n      background: var(--epw-soft);\n    }\n\n    .epw-future-label {\n      display: inline-block;\n      margin-bottom: 12px;\n      color: var(--epw-red);\n      font-size: 0.76rem;\n      font-weight: 800;\n      letter-spacing: 0.08em;\n      text-transform: uppercase;\n    }\n\n    .epw-future-card h3 {\n      margin: 0 0 8px;\n      font-size: 1.3rem;\n    }\n\n    .epw-future-card p {\n      margin: 0;\n      color: var(--epw-muted);\n    }\n\n    .epw-closing {\n      margin-top: 54px;\n      padding: 30px;\n      border: 1px solid var(--epw-line);\n      border-radius: 18px;\n      text-align: center;\n    }\n\n    .epw-closing strong {\n      display: block;\n      font-size: clamp(1.35rem, 2.5vw, 1.9rem);\n      margin-bottom: 8px;\n    }\n\n    .epw-closing p {\n      margin: 0 auto;\n      max-width: 760px;\n      color: var(--epw-muted);\n    }\n\n    @media (max-width: 900px) {\n      .epw-hero-grid,\n      .epw-global-band {\n        grid-template-columns: 1fr;\n      }\n\n      .epw-region-grid {\n        grid-template-columns: 1fr;\n      }\n\n      .epw-globe {\n        width: min(100%, 330px);\n      }\n    }\n\n    @media (max-width: 700px) {\n      .epw-expansion-grid {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    @media (max-width: 620px) {\n      .epw-coverage-hero {\n        padding: 54px 20px 50px;\n      }\n\n      .epw-main {\n        padding: 44px 18px 60px;\n      }\n\n      .epw-global-band,\n      .epw-closing,\n      .epw-region-card,\n      .epw-future-card {\n        padding: 22px;\n      }\n    }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
